export { _default as default };
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import EditNoteModalTemplate from 'text!../views/edit-note-modal.html';

var CreateActivityNoteController = function CreateActivityNoteController($filter, $scope, $modalInstance, ModalService, activity, ActivityService, ViewModelService) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.showLoading = false;
        var note = {
            subject: '',
            body: ''
        };
        $scope.note = ViewModelService.create(note, 'cc', 'edge.capabilities.note.dto.NoteDTO');
    };

    ctrl.sendNote = function (form) {
        form.submitted = true;
        if (form.invalid) {
            return;
        }
        $scope.showLoading = true;
        ActivityService.createActivityNote(activity.publicID.value, $scope.note.value).then(function (savedNote) {
            $modalInstance.close(savedNote);
            $scope.showLoading = false;
        }, function () {
            ModalService.showError('claim.controllers.EditNoteModal.Note creation failed', 'claim.controllers.EditNoteModal.Sorry, we were not able to add a new note to your activity.');
            $scope.showLoading = false;
        });
    };

    return ctrl.create($scope);
};
CreateActivityNoteController.$inject = ['$filter', '$scope', '$modalInstance', 'ModalService', 'activity', 'claim.ActivityService', 'ViewModelService'];

function _default(_activity) {
    this.template = EditNoteModalTemplate;
    this.controller = CreateActivityNoteController;
    this.resolve = {
        activity: function activity() {
            return _activity;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/controllers/EditNoteModal.js
// module id = 1418
// module chunks = 0